import React from 'react';
import * as styles from './styles.scss';

const Errors = ({ errors, translate = text => text }) => {
    if (!!errors && Array.isArray(errors)) {
        return (
            errors.map(
                ({ message }, index) => (
                    <div key={index} className={styles.errors}>
                        {translate(message)}
                    </div>
                ))
        );
    }

    if (!!errors) {
        return (
            <div className={styles.errors}>
                {translate(errors.toString())}
            </div>
        );
    }
};

export default Errors;
